import * as JWT from 'admin/utils/jwt';

const SETTING_SERVICE_UUID  = "3c46a55f-5890-0689-9025-e75f00000001";
const RESTART_CHAR_ID       = 0x0100;
const SETTINGS_CHAR_ID      = 0x0101;
const FW_CONTROL_CHAR_ID    = 0x0201;
const FW_DATA_CHAR_ID       = 0x0202;

const mixin = {

  async __readValueAll(char, type='binary') {
    let arr = new Uint8Array([]);
    while (true) {
      const value = await char.readValue();
      const next = new Uint8Array(arr.length + value.byteLength);
      next.set(arr);
      next.set(new Uint8Array(value.buffer), arr.length);
      arr = next;
      if (value.byteLength < 500) {
        break;
      }
    }
    switch (type) {
      case 'string':
        return String.fromCharCode.apply(null, arr);
    }
    return arr;
  },

  async __writeValueAll(char, data) {
    if (typeof data === 'string') {
      const len = data.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        arr[i] = data.charCodeAt(i);
      }
      data = arr;
    } else if (!(data instanceof Uint8Array)) {
      throw new Error('Supported only ascii-string or Uint8Array');
    }
    let acc = 0;
    while (true) {
      const chunk = data.slice(acc, acc+500);
      const clen = chunk.length;
      await char.writeValue(chunk);
      acc += clen;
      if (clen < 500) break;
    }
    return acc;
  },

  async bleReadSettings(device) {
    const server = await device.gatt.connect();
    try {
      const service = await server.getPrimaryService(SETTING_SERVICE_UUID);
      const char = await service.getCharacteristic(SETTINGS_CHAR_ID);
      const jwtStr = await this.__readValueAll(char, 'string');
      const jwt = JWT.decode(jwtStr);
      return jwt;
    } finally {
      device.gatt.disconnect();
    }
  },

  async bleWriteSettings(device, settingsJwt) {
    const server = await device.gatt.connect();
    try {
      const service = await server.getPrimaryService(SETTING_SERVICE_UUID);
      const char = await service.getCharacteristic(SETTINGS_CHAR_ID);
      return await this.__writeValueAll(char, settingsJwt);
    } finally {
      device.gatt.disconnect();
    }
  },

  async bleSearchDevice(hardware_id='') {
    const device = await navigator.bluetooth.requestDevice({
      filters: [{
        namePrefix: `PokePayPD_${hardware_id.slice(0,8).toLowerCase()}`
      }],
      optionalServices: [ SETTING_SERVICE_UUID ],
    });
    return device;
  },
};

export default mixin;
